export default {
    client: {
        NoPrivie: {
            title: '客户端管理',
            description: '一站式管理和配置应用接入渠道。实时监测在线状态，设置智能体在渠道端的触发、回复等策略，配置群聊和智能体的绑定关系。',
            dialogStrategyConfiguration: '对话策略配置',
            dialogStrategyConfigurationDescription: '支持分渠道配置应用/工作流',
            dialogStrategyConfigurationDescription2: '支持私聊、群聊的智能对话能力',
            dialogStrategyConfigurationDescription3: '支持语音识别和回复',
            offlineMonitoringNotification: '离线监控通知',
            offlineMonitoringNotificationDescription: '实时监测接入渠道的智能体运行状态',
            offlineMonitoringNotificationDescription2: '离线及时发送通知邮件',
            offlineMonitoringNotificationDescription3: '保障 AI 服务稳定运行',
            webPageConfiguration: '网页嵌入配置',
            webPageConfigurationDescription: '支持设置个性化的网页嵌入对话窗样式',
            webPageConfigurationDescription2: '支持设置指定页面不展示悬浮窗',
            webPageConfigurationDescription3: '支持图像、语音输入及转人工能力',

        },
        
        clientManagement: '客户端管理',
        offlineNotification: '离线通知',
        pleaseEnter: '请输入名称',
        webEmbed: '网页嵌入',
        pleaseSelectType: '请选择类型',
        pleaseSelectDeployType: '请选择部署类型',
        selfBuild: '自建',
        hosting: '托管',
        upgrade: '升级',
        pleaseSelectStatus: '请选择状态',
        offline: '离线',
        online: '在线',
        query: '查询',
        icon: '图标',
        type: '类型',
        status: '状态',
        operation: '操作',
        deployType: '部署类型',
        lastActiveTime: '最近活跃时间',
        login: '登录',
        configuration: '配置',
        edit: '编辑',
        delete: '删除',
        chat: '对话',
        clientEdit: '客户端编辑',
        clientName: '客户端名称：',
        pleaseEnterClientName: '请输入客户端名称',
        isEnabled: '是否启用',
        notificationChannel: '通知渠道',
        SMS: '短信',
        WECHAT_MP: '微信公众号',
        scanQrcode: '扫码登录',
        scanSuccess: '扫码成功',
        pleaseSelectNotificationChannel: '请选择通知渠道',
        setSuccess: '设置成功',
        openSuccess: '开启成功',
        closeSuccess: '关闭成功',
        editSuccess: '修改成功',
        editFail: '修改失败',
        deleteChannel: '删除通道',
        deleteChannelDescription: '是否确认删除此通道?',
        deleteChannelSuccess: '删除通道成功',
        deleteChannelFail: '删除通道失败',
        save: '保存',
        back: '返回',
        isEnabledConfiguration: '是否启用配置',
        isEnabledConfigurationDescription: '启用后将优先使用远程配置，未启用则使用本地配置',
        applicationConfiguration: '应用配置',
        dialogApplication: '对话应用',
        dialogApplicationDescription: '对话默认使用的LinkAI应用或工作流',
        selectYourGlobalApplication: '选择你的全局应用',
        groupChatApplicationMapping: '群聊应用映射',
        groupChatApplicationMappingDescription: '不同群聊与LinkAI应用的映射关系',
        inputGroupChatName: '输入群聊名称',
        selectAIApplication: '选择AI应用',
        add: '新增',
        singleChat: '单聊',
        triggerPrefix: '触发前缀',
        triggerPrefixDescription: '包含该前缀的消息才能触发机器人回复，对应配置 single_chat_prefix',
        replyPrefix: '回复前缀',
        replyPrefixDescription: '机器人回复时会携带的前缀，对应配置 single_chat_reply_prefix',
        pleaseEnterReplyPrefix: '请输入回复前缀',
        welcomeWords: '欢迎语',
        welcomeWordsDescription: '用户关注公众号时自动发送的欢迎语',
        pleaseEnterWelcomeWords: '请输入欢迎语',
        groupChat: '群聊',
        groupChatPrefix: '触发前缀',
        groupChatPrefixDescription: '包含该前缀的消息才能触发群内机器人回复，对应配置 group_chat_prefix',
        groupChatReplyPrefix: '回复前缀',
        groupChatReplyPrefixDescription: '机器人回复时会携带的前缀，对应配置 group_chat_reply_prefix',
        botName: '机器人名称',
        botNameDescription: '在群聊中使用机器人时需配置机器人名称，即飞书应用名称',
        pleaseEnterBotName: '请输入机器人名称',
        blackAndWhiteList: '黑白名单',
        groupNameWhiteList: '群聊白名单',
        groupNameWhiteListDescription: '群聊名称配置在这里才能触发自动回复，对应配置 group_name_white_list',
        pleaseEnterGroupName: '请输入群聊名称',
        userBlackList: '用户黑名单',
        userBlackListDescription: '加入该黑名单中的用户昵称将不会被回复，对应配置 nick_name_black_list',
        pleaseEnterUserBlackList: '请输入用户名称',
        voice: '语音',
        openVoiceRecognition: '开启语音识别',
        voiceRecognitionDescription: '开启后将会对语音消息识别为文字',
        replyMode: '回复模式',
        replyModeDescription: '选择在何种情况回复语音消息',
        selectYourReplyMode: '选择你的回复模式',
        drawPicture: '画图',
        imageModel: '图像模型',
        drawPictureDescription: '选择用于文生图的模型',
        selectYourImageModel: '选择你的图像模型',
        triggerPicturePrefix: '触发图片生成的前缀词',
        otherConfiguration: '其他配置',
        adminPassword: '管理员密码',
        adminPasswordDescription: '用于认证管理员指令，认证方式: #auth 密码',
        pleaseEnterAdminPassword: '请输入您的密码',
        streamCardOutput: '流式卡片输出',
        streamCardOutputDescription: '支持钉钉AI卡片效果，详见',
        dingTalkOpenPlatform: '钉钉开放平台',
        cardTemplateId: '卡片模板ID',
        goTo: '前往',
        createCardTemplateAndCopyTemplateId: '创建卡片模板并复制模板ID',
        pleaseEnterCardTemplateId: '请输入卡片模板ID',
        authorizationConfiguration: '授权配置',
        callbackAddress: '回调地址',
        botInviteLink: '机器人邀请链接',
        copy: '复制',
        pleaseEnterYour: '请输入您的',
        replyStrategy: '回复策略',
        manualIntervention: '人工介入：',
        manualInterventionDescription: '人工回复后',
        seconds: '秒内，AI不回复',
        voiceReplyVoice: '语音回复语音',
        alwaysReplyVoice: '总是回复语音',
        noReplyVoice: '不回复语音',
        copySuccess: '复制成功',
        all: '全部',
        application: '应用',
        flowwork: '工作流',
        submitAndPushToClient: '提交后将推送至客户端并生效，是否提交?',
        submit: '提交',
        saveSuccess: '保存成功',
        cancelSave: '取消保存',
        addAccount: '添加账号',
        privateChat: '私聊',
        pleaseSelectApplicationOrFlowwork: '请选择应用/工作流',
        open: '开启',
        openGroupCount: '开通群聊数：',
        isOpen: '是否开启',
        close: '关闭',
        syncGroupChat: '同步群聊',
        groupChatAvatar: '群聊头像',
        groupChatName: '群聊名称',
        cancelGroupChat: '注销群聊',
        selectProtocol: '选择协议',
        ipadScanCode: 'ipad扫码号',
        pcScanCode: 'PC扫码号',
        selectArea: '选择地区',
        pleaseSelectProvince: '请选择省份',
        pleaseSelectCity: '请选择城市',

        generateQrCode: '生成二维码',
        loginQrCode: '登录二维码',
        pleaseScanCodeAndWait: '请扫码后耐心等待',
        ifPromptInputVerificationCode: '如果提示输入验证码，请点击',
        inputVerificationCode: '输入验证码',
        pleaseEnterVerificationCode: '请输入验证码',
        submitSuccess: '提交成功',
        pleaseSelectProtocol: '请选择协议',
        switchSuccess: '成功切换',
        switchFail: '切换失败，请重试',
        isOpenApplicationBinding: '是否开启应用绑定?',
        bindApplication: '绑定应用',
        hostingSuccess: '托管成功',
        hostingFail: '托管失败，请重试',
        cancelBinding: '取消绑定',
        loginSuccess: '登录成功',
        loginException: '登录异常',
        syncGroupChatSuccess: '同步群聊成功',
        pleaseSelectAppCode: '请选择appCode',
        confirmCloseApplication: '是否确认关闭该应用?',
        closeApplication: '关闭应用',
        closeFail: '关闭失败，请重试',
        cancelOperation: '取消操作',
        pleaseBindApplication: '请先绑定应用',
        pleaseCloseAiReply: '请先关闭AI回复',
        confirmCancelGroupChat: '是否确认取消开通群聊?取消后需要重新同步该群聊才可使用',
        cancelGroupChat1: '取消开通群聊',
        cancelSuccess: '注销成功',
        privateChatConfiguration: '私聊配置',
        groupChatConfiguration: '群聊配置',
        groupChatNotConfigured: '群聊未单独配置时则使用该全局配置',
        triggerConditions: '触发条件',
        allReply: '全部回复',
        atReply: '@回复',
        conditionsReply: '满足条件回复',
        conditionsSetting: '条件设置：',
        conditionsSettingDescription: '当用户提问满足设置的条件组合时可触发AI回复',
        aiNotReplyDescription: '人工在渠道端进行回复后',
        pleaseEnter1: '请输入',
        voiceSetting: '语音设置',
        voiceQuestion: '语音提问：',
        voiceReply: '识别好友的语音消息进行回复',
        voiceReplyDescription: '识别群聊中的语音消息进行回复（与文字提问的触发条件设置无关）',
        triggerPrefixWord: '触发前缀词：',
        triggerPreFrom: {
            description1: '语音消息的前缀词拼音与设置的前缀词拼音一致时可触发AI回复',
            description2: '可设置多个前缀词，输入后回车确认',
            description3: '如未设置则默认所有语音消息都触发AI回复',
        },
        addPrefixWord: '输入内容后回车完成添加',
        addPrefixWordDescription: '输入内容后回车添加前缀词',
        voiceReply1: '语音回复：',
        voiceReplyDescription1: '将AI回复内容转为语音消息发送',
        voiceSelect: {
            onlyReplyVoice: '仅语音提问时回复语音',
            alwaysReplyVoice: '默认回复语音',
        },
        addFriendWelcome: '加好友欢迎语',
        groupChatWelcome: '进群欢迎语',
        noWelcomeMsg: '不发送欢迎语',
        fixedWelcomeMsg: '固定欢迎语',
        aiWelcomeMsg: 'AI生成欢迎语',
        welcomeSetting: '欢迎语设置：',
        insertVariable: '插入变量',
        welcomeStyle: {
            title: '欢迎语风格设置：',
            single: '用提示词设置AI欢迎语，可通过插入变量添加用户昵称，如“请用中性的风格欢迎用户添加你为好友，并说明可以随时向你提问”',
            group: '用提示词设置AI欢迎语，可通过插入变量添加群名称和用户昵称，如“请用中性的风格欢迎用户进入群聊，并说明可以随时@你提问”',
        },
        addConfiguration: '添加配置',
        deleteConfiguration: '删除配置',
        welcomeNewUser: '请你用中性的风格说一句简短的问候语来欢迎新用户 {{nick_name}} 加入群聊，并说明可以@你来提问，不要超过30个字。',
        welcomeNewFriend: '请你用中性的风格说一句简短的问候语来欢迎新朋友{{nick_name}}，并说明可以向你提问，不要超过30个字。',

        welcomeNewUser1: '请你用中性的风格说一句简短的问候语来欢迎新用户',
        welcomeNewFriend1: '请你用中性的风格说一句简短的问候语来欢迎新朋友',
        welcomeNewUser2: '加入群聊，并说明可以@你来提问，不要超过30个字',
        welcomeNewFriend2: '，并说明可以向你提问，不要超过30个字。',
        userNickName: '用户呢称',
        confirmDeleteGroupConfiguration: '是否确认删除该群的配置？删除后将使用群聊全局配置。',
        confirmDeleteConfiguration: '确认删除配置',
        deleteSuccess: '删除成功',
        cancelDelete: '取消删除',
        and: '且',
        or: '或',
        question: '提问',
        condition: '条件',
        value: '值',
        addConditions: '添加条件',
        conditions: '条件',
        operator: {
            contains: '包含',
            not_contains: '不包含',
            eq: '等于',
            neq: '不等于',
            pre_contains: '前缀匹配',
            post_contains: '后缀匹配',
        },
        IbotConfig: {
            baseSetting: '基础设置',
            setYourWebsiteBaseInfo: '设置您的网站基础信息',
            websiteName: '网站名称',
            websiteNameDescription: '以独立页面链接使用时，网站名称会在浏览器页签中显示',
            pleaseEnterIntegrateName: '请输入集成名称',
            dialogApplication: '对话应用',
            pleaseSelectDialogApplication: '请选择对话应用',
            windowTitle: '窗口标题',
            pleaseEnterWindowTitle: '请输入窗口标题',
            windowSubTitle: '窗口副标题',
            pleaseEnterWindowSubTitle: '请输入窗口副标题',
            welcomeWords: '欢迎语',
            welcomeWordsDescription: '这是首次进入对话时，智能助手向用户发送的第一条消息，支持Markdown格式。',
            forExample: '"[]" 符号生成引导问题，例如:',
            forExample1: '我是你的智能助手，你可以问我:',
            forExample2: '- [如何进行活动策划?]',
            forExample3: '应用的第一句话。例如:有什么可以帮您的?',
            inputBoxPrompt: '输入框提示：',
            pleaseEnter: '请输入',
            disablePage: '禁用页面：',
            disablePageDescription: '以悬浮窗口嵌入网站时，可设置网站内不需要展示悬浮窗的页面',
            add: '新增',
            serialNumber: '序号',
            disablePageAddress: '禁用页面地址',
            operation: '操作',
            delete: '删除',
            backgroundColor: '背景色：',
            voiceInput: '语音输入：',
            voiceInputDescription: '开启后用户可使用语音输入的方式在对话窗进行对话',
            clearRecord: '清除记录：',
            clearRecordDescription: '开启后，用户可在对话窗手动清除历史对话记录和保留的上下文记忆',
            integrationMethod: '集成方式',
            viewIntegrationMethod: '查看集成方式',
            methodOne: '方式一：',
            floatingWindow: '悬浮窗口嵌入',
            methodTwo: '方式二：',
            pageLink: '独立页面链接',
            methodThree: '方式三：',
            iframe: 'iframe嵌入',
            copyScript: '复制script标签内容，放在应用项目根路径html文件的<head>标签中',
            copy: '复制',
            advancedSetting: '高级设置',
            professionalFunction: '专业版功能，详见',
            versionDescription: '版本说明',
            setPersonalizedIconAndTransferToHuman: '设置个性化图标及转人工等',
            setPersonalizedIconAndTransferToHumanDescription: '设置悬浮窗口嵌入模式下展开/收起悬浮窗的按钮样式',
            floatingIcon: '悬浮图标',
            floatingIconDescription: '设置悬浮窗口嵌入模式下展开/收起悬浮窗的按钮样式',
            uploadFile: '上传文件',
            uploadFileDescription: '建议上传无背景颜色图片，建议尺寸48*48px，jpg、png格式',
            backToDefault: '恢复默认',
            botHeadImage: '机器人头像',
            noShowHeadImage: '不显示头像',
            uploadFile1: '上传文件',
            uploadFile1Description: '建议上传无背景颜色图片，建议尺寸36*36px，jpg、png格式',
            bottomIcon: '底部标识',
            bottomIconDescription: '建议上传无背景颜色图片，建议尺寸12*12px，jpg、png格式',
            bottomText: '底部标语',
            pleaseEnter20Characters: '请输入20个以内的字符',
            jumpAddress: '跳转地址',
            jumpAddressDescription: '点击底部标语可跳转第三方链接',
            pleaseEnterUrl: '请输入url',
            transferToHuman: '转人工',
            transferToHumanDescription: '开启后用户可在对话窗主动操作转人工，可结合应用配置“转人工”能力使用',
            needUpgradeToProfessionalVersion: '需升级至专业版使用',
            introduction: '开场介绍',
            applicationFirstSentence: '应用的第一句话。例如:有什么可以帮您的?',
            confirm: '确定',
            uploadFail: '上传失败',
            pleaseReLogin: '请重新登录',
            imageUploadOnlySupportJpegPngFormat: '图片上传只支持 jpeg,png 格式',
            imageSizeLessThan5MB: '图片大小需小于 5MB!',
            copySuccess: '复制成功',
            websiteNameRequired: '网站名称必填！',
            bindApplicationRequired: '绑定应用必填！',
            application: '应用',
            flowwork: '工作流',
        }
    }
};